import { getTeamLeaguesSeasonInfoUseCase } from '@/domain/use-cases/get-team-league-season-info.use-case';

export const getTeamLeagueSeasonInfoController = async (teamLeagueUuid: string, organizationUuid: string) => {
	return getTeamLeaguesSeasonInfoUseCase(teamLeagueUuid, organizationUuid);
};
